import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleProjectsTransfer(
  state: State,
  { projects, destination }: Boundaries["transferProjects"]["success"],
): State {
  return {
    ...state,
    projects: [
      ...state.projects.filter(
        (project) => !projects.find(({ uuid }) => uuid === project.uuid),
      ),
      ...projects.map((project) => ({ ...project, zone: destination })),
    ],
  };
}

export { handleProjectsTransfer };
